<template>
	<div style="min-height: 500px;">
        <div class="flex justify-between mb-5 border-b border-gray-200 pb-2">
            <div v-if="showHeader" class="flex items-center">
                <h1 class="module-header">Changelog</h1>
            </div>
            <div v-if="showFilters" class="flex items-center" :class="{'flex-1 justify-end pt-4 pb-3': ! showHeader}">
                <filters
                    data-type="changeLog"
                    sort-by="created_at"
                    :sort-asc="false"
                    :show-view-options="false"
                    :show-client-filter="false">
                </filters>
            </div>
        </div>
        <div v-if="changeLog.filtered.length">
	        <table class="w-full">
	            <thead class="cursor-pointer">
	            	<tr>
		                <th class="text-center">Date</th>
	                	<th>Changed By</th>
	                	<th>Changes</th>
	                </tr>
	            </thead>
            	<paginate name="changeLog.filtered" :list="changeLog.filtered" :per="perPage" tag="tbody">
	                <tr v-for="(audit, auditIndex) in paginated('changeLog.filtered')" :key="auditIndex">
	                    <td class="text-center">{{ audit.created_at | date }}</td>
	                    <td class="leading-normal">
	                        <p class="text-lg font-semibold">{{ audit.user.name }}</p>
	                        <p>{{ audit.ip_address }}</p>
	                    </td>
	                    <td class="w-3/4">
	                        <ol class="leading-normal">
	                            <li v-for="(old, index) in audit.old_values" :key="index">
	                                <strong>{{ index }}</strong> changed from <strong>{{ old || '-' }}</strong> to <strong>{{ audit.new_values[index] || '-' }}</strong>
	                            </li>
	                            <li v-if="audit.event == 'created'">Created</li>
	                        </ol>
	                    </td>
	                </tr>
				</paginate>
	        </table>
	        <paginate-links for="changeLog.filtered" :show-step-links="true" :hide-single-page="true"></paginate-links>
		</div>
        <div v-else>
            <p class="none-found">No Changes Found</p>
        </div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';

	export default {
		props: {
			data: {
				type: [Array, Object],
				required: true
			},

			showHeader: {
				type: Boolean,
				default: true
			},

			showFilters: {
				type: Boolean,
				default: true
			},

            perPage: {
                type: Number,
                default: 10
            }
		},

		data() {
			return {
				paginate: ['changeLog.filtered'],
			}
		},

        mounted() {
            this.changeLog.all = this.data;
            this.changeLog.filtered = this.data;

            this.$emit('filterRequest');
        },

        computed: {
            ...mapState(['changeLog']),
		}
	}
</script>